var i = function (n, o) {
  n && ("focus" in n && n.focus(o), "contentWindow" in n && n.contentWindow && n.contentWindow.focus());
};
export { i as focusOn };